import Skeleton from '@carvana/ds-skeleton';

const FilterMenuItem = () => (
  <div className="flex justify-between border-b border-border-subtle px-2xl pb-2xl pt-2xl">
    <Skeleton width="160px" height="24px" />
  </div>
);

// Shown in place of FiltersMenu until server facet data hydrates, so the menu doesn't
// flash the baseline option set first. Shared with SearchResultsLoadingSkeleton.
export default function FiltersMenuSkeleton() {
  return (
    <>
      {Array.from({ length: 15 }).map((_, index) => (
        <FilterMenuItem key={index} />
      ))}
    </>
  );
}
